import {
  SET_IS_LOADING,
  SET_GENERATED_SECTION,
  type AiHtmlSectionActions,
} from './aiHtmlSectionActions';

export interface AiHtmlSectionState {
  isLoading: boolean;
  generatedSection?: string;
}

const aiHtmlSectionInititalState: AiHtmlSectionState = {
  isLoading: false,
  generatedSection: undefined,
};

export const aiHtmlSectionReducer = (
  state = aiHtmlSectionInititalState,
  action: AiHtmlSectionActions,
): AiHtmlSectionState => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    case SET_GENERATED_SECTION: {
      return {
        ...state,
        generatedSection: action.generatedSection,
      };
    }
    default:
      return state;
  }
};
